/**
 * Header Component
 * shadcn-inspired luxury navbar — frosted glass, clean typography, rounded CTA
 */

import { COMPANY_INFO, NAVIGATION_LINKS } from '../utils/constants';

export function createHeader(): string {
  return `
    <!-- ════════════════════════════════════
         NAVIGATION
    ════════════════════════════════════ -->
    <nav id="nav" role="navigation" aria-label="Main navigation">
      <div class="nav-inner">

        <!-- ── Logo ── -->
        <a href="#" class="nav-logo-link" aria-label="${COMPANY_INFO.name} home">
          <div class="nav-logo-clip">
            <img
              src="${COMPANY_INFO.logo}"
              alt="${COMPANY_INFO.name} logo"
              class="nav-logo-img"
            >
          </div>
        </a>

        <!-- ── Desktop Links ── -->
        <div class="nav-links">
          ${NAVIGATION_LINKS.map(
    (link) => `<a href="${link.href}" class="nav-link">${link.label}</a>`
  ).join('\n          ')}
        </div>

        <!-- ── Desktop Right Side ── -->
        <div class="nav-actions">
          <span class="nav-divider" aria-hidden="true"></span>
          <a href="/contact.html" class="nav-cta">
            Contact Us
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
              <path d="M1 4H11M8 1L11 4L8 7" stroke="currentColor" stroke-width="1.25"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>

        <!-- ── Hamburger (mobile only) ── -->
        <button id="hamburger" class="nav-hamburger" aria-label="Open menu" aria-expanded="false">
          <span class="ham-bar ham-bar-top"></span>
          <span class="ham-bar ham-bar-mid"></span>
          <span class="ham-bar ham-bar-bot"></span>
        </button>

      </div>
    </nav>

    <!-- ── Mobile Menu ── -->
    <div id="mobile-menu" class="mobile-menu" style="display:none;">
      <div class="mobile-menu-inner">

        <div class="mobile-links">
          ${NAVIGATION_LINKS.map(
    (link) => `<a href="${link.href}" class="mobile-link">${link.label}</a>`
  ).join('\n          ')}
        </div>

        <div class="mobile-menu-footer">
          <a href="/contact.html" class="nav-cta" style="align-self:flex-start;">
            Contact Us
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
              <path d="M1 4H11M8 1L11 4L8 7" stroke="currentColor" stroke-width="1.25"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
            ${COMPANY_INFO.location}
          </span>
        </div>

      </div>
    </div>
  `;
}

export default createHeader;
